import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["navElevation", "elevation"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { VerticalNavItem } from '../VerticalNavItem/VerticalNavItem';
import { VerticalNavList } from '../VerticalNavList/VerticalNavList';
import { StyledVerticalNav } from './VerticalNav.styles';

/**
 * @subcomponents ['VerticalNav.List', 'VerticalNav.Item']
 * @since 8.72.0
 */

export var VerticalNav = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var navElevation = _ref.navElevation,
    elevation = _ref.elevation,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isElevationBool = typeof elevation === 'boolean';
  var props = Object.assign({}, rest, {
    navElevation: navElevation && isElevationBool ? elevation : navElevation
  });
  return /*#__PURE__*/React.createElement(StyledVerticalNav, _extends({
    ref: forwardedRef
  }, props));
});
VerticalNav.displayName = 'VerticalNav';
VerticalNav.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This prop if true adds a border
   */
  border: PropTypes.bool,
  /**
   * This prop if true adds a background color, false will be transparent
   */
  background: PropTypes.bool,
  /**
   * A group of `VerticalNav.List` components.
   */
  children: PropTypes.node.isRequired,
  /**
   * This prop if true adds a dropshadow. Use this in favor of `elevation`
   * which will be deprecated.
   */
  navElevation: PropTypes.bool,
  /**
   * @deprecated We are deprecating the use of elevation because it is a reserved HTML
   * attribute for SVG's [`feDistantLight`](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/elevation).
   * Please use `navElevation` instead.
   *
   * This prop if true adds a dropshadow
   */
  elevation: PropTypes.bool,
  /**
   * Use the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * to change the HTML tag of the component.
   *
   * This can be used to apply `Button` styling to HTML anchors, inputs, and custom components.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any
} : {};
VerticalNav.defaultProps = {
  border: true,
  background: true,
  navElevation: true
};
VerticalNav.List = VerticalNavList;
VerticalNav.Item = VerticalNavItem;